<div
  fxLayout="row"
  fxLayoutAlign="center start"
  class="centered-container"
  fxFlexFill
>
  <mat-card
    class="signup-card mat-elevation-z4"
    ngClass.gt-xs="signup-card-top-margin"
    fxLayout="column"
    fxLayoutAlign="space-around center"
    fxFlex="100"
    fxFlex.gt-xs="50"
  >
    <h1>Register</h1>
    <div fxFill fxLayout="column" fxLayoutAlign="space-around center">
      <button
        fxFill
        class="signup-button google-button"
        mat-stroked-button
        (click)="loginWithGoogle()"
      >
        <img
          class="signup-icon google-icon"
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
        /><span>Register With Google</span>
      </button>
      <button fxFill class="signup-button facebook-button" mat-stroked-button>
        <img
          class="signup-icon facebook-icon"
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/facebook.svg"
        />Register With Facebook
      </button>
      <button
        fxFill
        routerLink="email"
        class="signup-button mail-button"
        mat-stroked-button
      >
        <img
          class="signup-icon mail-icon"
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/mail.svg"
        />Register With Email
      </button>
      <button
        fxFill
        routerLink="phone"
        class="signup-button phone-button"
        mat-stroked-button
      >
        <img
          class="signup-icon phone-icon"
          src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/phone.svg"
        />Register With Phone
      </button>
    </div>
    <div>Already have an account? <a routerLink="/login">Log In.</a></div>
  </mat-card>
</div>

